import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';
import { convertHttpsToS3Url } from '@/utils';
import { useSessionContext } from '@/contexts/SessionContext';
var HLSPlayer = function (_a) {
    var video = _a.video, src = _a.src, innerRef = _a.innerRef;
    var _b = useSessionContext(), subdomain = _b.subdomain, token = _b.token;
    var hlsRef = useRef(null);
    useEffect(function () {
        if (!video)
            return;
        if (Hls.isSupported()) {
            var hls = new Hls({
                xhrSetup: function (xhr, url) {
                    var _a, _b;
                    console.log("HLS_VARIANT", url);
                    if (url.indexOf('.m3u8') > -1) {
                        var s3Url = convertHttpsToS3Url(url);
                        var isAdmin = ((_b = (_a = window.location) === null || _a === void 0 ? void 0 : _a.href) === null || _b === void 0 ? void 0 : _b.indexOf('admin')) > -1;
                        var newUrl = "".concat(process.env.REACT_APP_API_URL, "?action=get_m3u8_playlist&s3_url=").concat(s3Url);
                        xhr.open("GET", newUrl, true);
                        xhr.setRequestHeader('Authorization', "Bearer ".concat(token));
                        if (subdomain)
                            xhr.setRequestHeader('x-domain', subdomain);
                    }
                }
            });
            hlsRef.current = hls;
            hls.loadSource(src);
            hls.attachMedia(video);
            hls.on(Hls.Events.MANIFEST_PARSED, function () {
                //video.play().catch((e: any) => console.log('Play failed:', e));
            });
        }
        else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            // For browsers that support HLS natively (e.g., Safari)
            video.src = src;
            video.addEventListener('loadedmetadata', function () {
                //video.play().catch((e: any) => console.log('Play failed:', e));
            });
        }
        return function () {
            if (hlsRef.current) {
                hlsRef.current.destroy();
            }
        };
    }, [src, token]);
    var seekTo = function (timeInSeconds) {
        if (video && video.readyState) {
            video.currentTime = timeInSeconds;
        }
    };
    React.useImperativeHandle(innerRef, function () { return ({
        seekTo: seekTo
    }); }, [video]);
    return (_jsx("source", { src: src, type: "application/x-mpegURL" }));
};
export default HLSPlayer;
